module.exports = __webpack_public_path__ + "static/media/accuracy@2x.c68b5cb4.png";